<template>
  <div class="d-flex flex-column">
    <div class="mb-3">
      <Photos
        :photos="photos"
        :job-id="job.id"
        :upload-link="job.links.reserve_s3_photos"
        @upload-success="handlePhotosUploaded"
        @delete-success="handlePhotoDeleted"
      />
    </div>
    <FeatureFlag feature="video_uploads">
      <div class="mb-3">
        <Videos
          :videos="videos"
          :job-id="job.id"
          @upload-success="handleVideosUploaded"
          @delete-success="handleVideoDeleted"
        />
      </div>
    </FeatureFlag>
    <Docs
      :documents="documents"
      :job-id="job.id"
      :upload-link="job.links.reserve_s3_documents"
      @upload-success="handleDocumentsUploaded"
      @delete-success="handleDocumentDeleted"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import FeatureFlag from "@/components/FeatureFlag.vue";
import Docs from "@/Documents/Documents.vue";
import Photos from "@/PhotoGallery/PhotoGallery.vue";
import { Document } from "@/typings/document";
import { Job } from "@/typings/job";
import { Photo } from "@/typings/photo";
import { Video } from "@/typings/video";
import Videos from "@/VideoGallery/VideoGallery.vue";

const store = useStore();

const job = computed<Job>(() => store.state.job);
const photos = computed<Photo[]>(() => job.value?.photos);
const documents = computed<Document[]>(() => job.value?.documents);
const videos = computed<Video[]>(() => job.value?.videos);

function handlePhotosUploaded() {
  store.dispatch("fetchJob", { jobId: job.value.id });
}

function handlePhotoDeleted(photoId) {
  job.value.photos = photos.value.filter((photo) => {
    return photo.id !== photoId;
  });
}

function handleDocumentsUploaded(uploadedDocs) {
  job.value.documents = documents.value.concat(uploadedDocs);
}

function handleDocumentDeleted(documentId) {
  job.value.documents = documents.value.filter((document) => {
    return document.id !== documentId;
  });
}

function handleVideosUploaded() {
  store.dispatch("fetchJob", { jobId: job.value.id });
}

function handleVideoDeleted(videoId) {
  job.value.videos = videos.value.filter((video) => {
    return video.id !== videoId;
  });
}
</script>

<style>
.bottom-separator {
  @apply text-xs opacity-50;
  color: var(--sera-color-neutral-gray-med-gray-600);
}
</style>
